import React from 'react';

export default () => (<div className="project" id="project-3">
  <div className="slogan">
    <img src={process.env.PUBLIC_URL + '/images/project/project-3-slogan.png'} alt="商洛市镇安县1000亩七叶树基地建设" />
  </div>
  <div className="content">
    <div id="constructions">
      <div className="title">
        <span>建设内容</span>
      </div>
      <div className="constructions">
        <div className="construction" id="construction-1">
          <div className="icon icon-project-construction-first"></div>
          <div className="name">
            <span>1000亩七叶树基地建设</span>
          </div>
          <div className="desc">
            <span>土地的规整</span>
            <span>七叶树的种植</span>
            <span>管理及抚育</span>
          </div>
        </div>
        <div className="construction" id="construction-2">
          <div className="icon icon-project-construction-second"></div>
          <div className="icon second"></div>
          <div className="name">
            <span>品种开发及销售</span>
          </div>
          <div className="desc">
            <span>推广种植</span>
            <span>产销联合</span>
            <span>产品的深加工</span>
          </div>
        </div>
        <div className="construction" id="construction-3">
          <div className="icon icon-project-construction-third"></div>
          <div className="icon third"></div>
          <div className="name">
            <span>基础设施的建设</span>
          </div>
          <div className="desc">
            <span>道路的建设</span>
            <span>给排水的建设</span>
            <span>环境建设</span>
            <span>固定资产的投入</span>
          </div>
        </div>
      </div>
    </div>
    <div className="crossline-container">
      <div id="advantages">
        <div className="title">
          <div className="icon icon-project-advantages"></div>
          <div className="name">项目特色及优势</div>
        </div>
        <div className="advantage">
          <span>七叶树具有成活率高、经济价值高、易于营造速生丰产林，可带动周边农民的种植，具体辐射带动作用。</span>
        </div>
        <div className="advantage">
          <span>经济价值高、可综合利用。七叶树全身都是宝，从根、茎、叶、果实、树干均具有很高的经济价值，可综合利用，对周边农民的致富带动能力强。</span>
        </div>
        <div className="advantage">
          <span>集育苗、种植、抚育、深加工为一体，具有功能复合性，可作物全国现代经济林区的标版。</span>
        </div>
        <div className="advantage">
          <span>七叶树果实可提取七叶皂苷钠，为无可替代的药品，经济价值极高，对其进行有效成分的提取及加工对镇安乃至秦岭山区的经济作物的产业的深加工具有帮助带头作用。</span>
        </div>
        <div className="advantage">
          <span>基地实现有机化全产业链，对秦岭山区的生态保护起到带头示范作用。</span>
        </div>
      </div>
    </div>
    <div id="extras">
      <div className="extra effect">
        <div className="icon icon-project-effect"></div>
        <div className="title">
          七叶树的功效
      </div>
        <div className="desc">
          <div>
            <span>叶子、花：食品，染料</span>
            <span>皮、根：饮品，染料</span>
          </div>
          <div>
            <span>种子：食品，入药，杀虫</span>
            <span>树干：木材加工业</span>
          </div>
          <div>
            <span>整树：观赏，保护环境</span>
          </div>
        </div>
        <div className="title">
          生物提取
      </div>
        <div className="desc">
          <div>七叶素：抗过敏、提高免疫力、消炎</div>
          <div>七叶皂苷钠：心脑血管疾病、脑损伤、水肿、神经性疾病</div>
        </div>
      </div>
      <div className="extra target">
        <div className="icon icon-project-tech-advantages"></div>
        <div className="title">
          未来发展目标
      </div>
        <div className="desc">
          <div>七叶树种植示范基地1000亩</div>
          <div>实现年经济收入达800万元</div>
          <div>实现年利润300万元</div>
          <div>带动周边农民就业200余人</div>
          <div>农民增收一倍以上。</div>
        </div>
      </div>
    </div>
    <div className="background"></div>
  </div>
</div>
);